import { SET_API_CALLED_KEY_EXPLORE_TOPICS } from '../../constants';
import { withType } from '../../../utils/actionOperations';

export const setIsApiCalled = () => {
  return dispatch => {
    dispatch(withType(SET_API_CALLED_KEY_EXPLORE_TOPICS));
  };
};
